/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type AssignStaffToMatchInput = {
  matchID: string | number;
  staffGUID: string | number;
};

export type UnassignStaffFromMatchInput = {
  matchID: string | number;
  staffGUID: string | number;
};

export type MatchAssignedStaffManagerModalStaffFragment = { guid: string, displayName: string };

export type MatchAssignedStaffManagerModalQueryVariables = Exact<{
  chatRoomId: string | number;
}>;


export type MatchAssignedStaffManagerModalQuery = { viewer: { staff: { guid: string } }, staffsByPlanner: Array<{ guid: string, displayName: string }>, ownChatRoom: { match: { id: string, assignedStaffs: Array<{ guid: string, displayName: string }> } } | null };

export type AssignStaffToMatchMutationVariables = Exact<{
  input: Types.AssignStaffToMatchInput;
}>;


export type AssignStaffToMatchMutation = { assignStaffToMatch:
    | { __typename: 'AssignStaffToMatchErrorNotAuthorityPayload' }
    | { __typename: 'AssignStaffToMatchSuccessPayload', match: { id: string, assignedStaffs: Array<{ guid: string, displayName: string }> } }
   };

export type UnassignStaffFromMatchMutationVariables = Exact<{
  input: Types.UnassignStaffFromMatchInput;
}>;


export type UnassignStaffFromMatchMutation = { unassignStaffFromMatch:
    | { __typename: 'UnassignStaffFromMatchErrorNotAuthorityPayload' }
    | { __typename: 'UnassignStaffFromMatchSuccessPayload', match: { id: string, assignedStaffs: Array<{ guid: string, displayName: string }> } }
   };

export const MatchAssignedStaffManagerModalStaffFragmentDoc = gql`
    fragment MatchAssignedStaffManagerModalStaff on Staff {
  guid
  displayName
}
    `;
export const MatchAssignedStaffManagerModalDocument = gql`
    query MatchAssignedStaffManagerModal($chatRoomId: ID!) {
  viewer {
    staff {
      guid
    }
  }
  staffsByPlanner {
    ...MatchAssignedStaffManagerModalStaff
  }
  ownChatRoom(id: $chatRoomId) {
    match {
      id
      assignedStaffs {
        ...MatchAssignedStaffManagerModalStaff
      }
    }
  }
}
    ${MatchAssignedStaffManagerModalStaffFragmentDoc}`;

/**
 * __useMatchAssignedStaffManagerModalQuery__
 *
 * To run a query within a Vue component, call `useMatchAssignedStaffManagerModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useMatchAssignedStaffManagerModalQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useMatchAssignedStaffManagerModalQuery({
 *   chatRoomId: // value for 'chatRoomId'
 * });
 */
export function useMatchAssignedStaffManagerModalQuery(variables: MatchAssignedStaffManagerModalQueryVariables | VueCompositionApi.Ref<MatchAssignedStaffManagerModalQueryVariables> | ReactiveFunction<MatchAssignedStaffManagerModalQueryVariables>, options: VueApolloComposable.UseQueryOptions<MatchAssignedStaffManagerModalQuery, MatchAssignedStaffManagerModalQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MatchAssignedStaffManagerModalQuery, MatchAssignedStaffManagerModalQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MatchAssignedStaffManagerModalQuery, MatchAssignedStaffManagerModalQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<MatchAssignedStaffManagerModalQuery, MatchAssignedStaffManagerModalQueryVariables>(MatchAssignedStaffManagerModalDocument, variables, options);
}
export function useMatchAssignedStaffManagerModalLazyQuery(variables?: MatchAssignedStaffManagerModalQueryVariables | VueCompositionApi.Ref<MatchAssignedStaffManagerModalQueryVariables> | ReactiveFunction<MatchAssignedStaffManagerModalQueryVariables>, options: VueApolloComposable.UseQueryOptions<MatchAssignedStaffManagerModalQuery, MatchAssignedStaffManagerModalQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MatchAssignedStaffManagerModalQuery, MatchAssignedStaffManagerModalQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MatchAssignedStaffManagerModalQuery, MatchAssignedStaffManagerModalQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<MatchAssignedStaffManagerModalQuery, MatchAssignedStaffManagerModalQueryVariables>(MatchAssignedStaffManagerModalDocument, variables, options);
}
export type MatchAssignedStaffManagerModalQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<MatchAssignedStaffManagerModalQuery, MatchAssignedStaffManagerModalQueryVariables>;
export const AssignStaffToMatchDocument = gql`
    mutation assignStaffToMatch($input: AssignStaffToMatchInput!) {
  assignStaffToMatch(input: $input) {
    __typename
    ... on AssignStaffToMatchSuccessPayload {
      match {
        id
        assignedStaffs {
          ...MatchAssignedStaffManagerModalStaff
        }
      }
    }
  }
}
    ${MatchAssignedStaffManagerModalStaffFragmentDoc}`;

/**
 * __useAssignStaffToMatchMutation__
 *
 * To run a mutation, you first call `useAssignStaffToMatchMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAssignStaffToMatchMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAssignStaffToMatchMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useAssignStaffToMatchMutation(options: VueApolloComposable.UseMutationOptions<AssignStaffToMatchMutation, AssignStaffToMatchMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AssignStaffToMatchMutation, AssignStaffToMatchMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AssignStaffToMatchMutation, AssignStaffToMatchMutationVariables>(AssignStaffToMatchDocument, options);
}
export type AssignStaffToMatchMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AssignStaffToMatchMutation, AssignStaffToMatchMutationVariables>;
export const UnassignStaffFromMatchDocument = gql`
    mutation unassignStaffFromMatch($input: UnassignStaffFromMatchInput!) {
  unassignStaffFromMatch(input: $input) {
    __typename
    ... on UnassignStaffFromMatchSuccessPayload {
      match {
        id
        assignedStaffs {
          ...MatchAssignedStaffManagerModalStaff
        }
      }
    }
  }
}
    ${MatchAssignedStaffManagerModalStaffFragmentDoc}`;

/**
 * __useUnassignStaffFromMatchMutation__
 *
 * To run a mutation, you first call `useUnassignStaffFromMatchMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUnassignStaffFromMatchMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUnassignStaffFromMatchMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUnassignStaffFromMatchMutation(options: VueApolloComposable.UseMutationOptions<UnassignStaffFromMatchMutation, UnassignStaffFromMatchMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UnassignStaffFromMatchMutation, UnassignStaffFromMatchMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UnassignStaffFromMatchMutation, UnassignStaffFromMatchMutationVariables>(UnassignStaffFromMatchDocument, options);
}
export type UnassignStaffFromMatchMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UnassignStaffFromMatchMutation, UnassignStaffFromMatchMutationVariables>;